import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthContextProvider } from 'shared/context/auth-context';
// import worker from 'mocks/browser'
import { ConfigProvider } from 'antd';
import elGR from 'antd/lib/locale/el_GR';
import 'moment/locale/el';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//  if (process.env.NODE_ENV === 'development') {
//  worker.start()
// } 
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <AuthContextProvider>
    <React.StrictMode>
      <ConfigProvider locale={elGR}>
        <App />
      </ConfigProvider>
    </React.StrictMode>
  </AuthContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
